import {TooltipConfig} from './tooltip-config.interface';

export const tooltipDefaultConfig: TooltipConfig = {
    glossaryIdAttribute: 'glossary-id'
}